/**
 * Página de Tests: selector de tipo + tabla CRUD dinámica por tipo.
 */
import { useEffect, useState, useCallback, useMemo, useRef } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import CrudPage from './shared/CrudPage';
import DificultadBadge from './shared/DificultadBadge';
import {
  TEST_TIPOS, getTests, createTest, updateTest, deleteTest,

  getTareas, getListas, getCategorias, getLenguajes, getUsuarios, setTestMode, unsetTestMode,
} from '../../api/adminClient';

export const DIFICULTAD_OPTS = [
  { value: 1, label: 'Facil',       activeClass: 'bg-emerald-500 text-white border-emerald-500', inactiveClass: 'text-emerald-700 border-emerald-300 hover:bg-emerald-50' },
  { value: 2, label: 'Medio',       activeClass: 'bg-amber-500 text-white border-amber-500',    inactiveClass: 'text-amber-700 border-amber-300 hover:bg-amber-50' },
  { value: 3, label: 'Dificil',     activeClass: 'bg-orange-500 text-white border-orange-500',  inactiveClass: 'text-orange-700 border-orange-300 hover:bg-orange-50' },
  { value: 4, label: 'Muy dificil', activeClass: 'bg-red-500 text-white border-red-500',        inactiveClass: 'text-red-700 border-red-300 hover:bg-red-50' },
];

const FIELDS_BY_TIPO = {
  libretest: [

    { key: 'id_tiposubtest',     label: 'Tarea',            type: 'select', options: [], colSpan: 2 },
    { key: 'descripcion',        label: 'Descripción',      required: true, colSpan: 2 },
    { key: 'id_usuario',         label: 'Creado por',       type: 'select', options: [] },
    { key: 'id_listavalores',    label: 'Lista de valores', type: 'select', options: [] },
    { key: 'dificultad',         label: 'Dificultad',       type: 'pill-select', options: DIFICULTAD_OPTS, defaultValue: 1 },
    { key: 'tiempo_mili',        label: 'Tiempo (ms)',      type: 'number', defaultValue: 1500 },
    { key: 'tiempo_miliPalabra', label: 'Tiempo por palabra', type: 'number', defaultValue: 1500 },
    { key: 'tiempo_milimascara', label: 'Tiempo máscara',   type: 'number', defaultValue: 500 },
    { key: 'instrucciones',      label: 'Instrucciones',    type: 'textarea', colSpan: 2 },
    { key: 'Concluciones',       label: 'Conclusiones',     type: 'textarea', colSpan: 2 },
    { key: 'observaciones',      label: 'Observaciones',    type: 'textarea', colSpan: 2 },
    { key: '_flags', label: 'Opciones', type: 'flag-group', items: [
      { key: 'ResultadoMilisegundos', label: 'Resultado en ms' },
      { key: 'ResultadosCorrectos',   label: 'Resultados correctos' },
      { key: 'baja',                  label: 'Baja' },
      { key: 'test_mode',              label: 'Modo test' },
    ]},
  ],
  rotacion: [
    { key: 'id_tiposubtest',  label: 'Tarea',            type: 'select', options: [], colSpan: 2 },
    { key: 'descripcion',     label: 'Descripción',      required: true, colSpan: 2 },
    { key: 'id_usuario',      label: 'Creado por',       type: 'select', options: [] },
    { key: 'id_listavalores', label: 'Lista de valores', type: 'select', options: [] },
    { key: 'dificultad',      label: 'Dificultad',       type: 'pill-select', options: DIFICULTAD_OPTS, defaultValue: 1 },
    { key: 'tiempo_mili',     label: 'Tiempo (ms)',      type: 'number', defaultValue: 1500 },
    { key: 'tiempo_milimax',  label: 'Tiempo máx (ms)', type: 'number', defaultValue: 5000 },
    { key: 'Concluciones',    label: 'Conclusiones',     type: 'textarea', colSpan: 2 },
    { key: 'observaciones',   label: 'Observaciones',    type: 'textarea', colSpan: 2 },
    { key: '_flags', label: 'Opciones', type: 'flag-group', items: [
      { key: 'baja', label: 'Baja' },
      { key: 'test_mode', label: 'Modo test' },
    ]},
  ],
  priming: [
    { key: 'id_tiposubtest',     label: 'Tarea',            type: 'select', options: [], colSpan: 2 },
    { key: 'descripcion',        label: 'Descripción',      required: true, colSpan: 2 },
    { key: 'id_usuario',         label: 'Creado por',       type: 'select', options: [] },
    { key: 'id_listavalores',    label: 'Lista de valores', type: 'select', options: [] },
    { key: 'dificultad',         label: 'Dificultad',       type: 'pill-select', options: DIFICULTAD_OPTS, defaultValue: 1 },
    { key: 'tiempo_miliPalabra', label: 'Tiempo palabra',   type: 'number', defaultValue: 1500 },
    { key: 'tiempo_milimascara', label: 'Tiempo máscara',   type: 'number', defaultValue: 250 },
    { key: 'Concluciones',       label: 'Conclusiones',     type: 'textarea', colSpan: 2 },
    { key: 'observaciones',      label: 'Observaciones',    type: 'textarea', colSpan: 2 },
    { key: '_flags', label: 'Opciones', type: 'flag-group', items: [
      { key: 'baja', label: 'Baja' },
      { key: 'test_mode', label: 'Modo test' },
    ]},
  ],
  memoriaacortopalabras: [
    { key: 'id_tiposubtest',   label: 'Tarea',             type: 'select', options: [], colSpan: 2 },
    { key: 'descripcion',      label: 'Descripción',       required: true, colSpan: 2 },
    { key: 'id_usuario',       label: 'Creado por',        type: 'select', options: [] },
    { key: 'id_listavalores',  label: 'Lista de valores',  type: 'select', options: [] },
    { key: 'dificultad',       label: 'Dificultad',        type: 'pill-select', options: DIFICULTAD_OPTS, defaultValue: 1 },
    { key: 'tiempo_mili',      label: 'Tiempo (ms)',       type: 'number', defaultValue: 1500 },
    { key: 'porcentajeValido', label: 'Porcentaje válido', type: 'number', defaultValue: 0 },
    { key: 'instrucciones',    label: 'Instrucciones',     type: 'textarea', colSpan: 2 },
    { key: 'Concluciones',     label: 'Conclusiones',      type: 'textarea', colSpan: 2 },
    { key: 'observaciones',    label: 'Observaciones',     type: 'textarea', colSpan: 2 },
    { key: '_flags', label: 'Opciones', type: 'flag-group', items: [
      { key: 'baja', label: 'Baja' },
      { key: 'test_mode', label: 'Modo test' },
    ]},
  ],
  digitosdirectosinversos: [
    { key: 'id_tiposubtest',  label: 'Tarea',            type: 'select', options: [], colSpan: 2 },
    { key: 'descripcion',     label: 'Descripción',      required: true, colSpan: 2 },
    { key: 'id_usuario',      label: 'Creado por',       type: 'select', options: [] },
    { key: 'id_listavalores', label: 'Lista de valores', type: 'select', options: [] },
    { key: 'dificultad',      label: 'Dificultad',       type: 'pill-select', options: DIFICULTAD_OPTS, defaultValue: 1 },
    { key: 'tiempo_mili',     label: 'Tiempo (ms)',      type: 'number', defaultValue: 1000 },
    { key: 'instrucciones',   label: 'Instrucciones',    type: 'textarea', colSpan: 2 },
    { key: 'Conclusiones',    label: 'Conclusiones',     type: 'textarea', colSpan: 2 },
    { key: 'observaciones',   label: 'Observaciones',    type: 'textarea', colSpan: 2 },
    { key: '_flags', label: 'Opciones', type: 'flag-group', items: [
      { key: 'OrdenInverso', label: 'Orden inverso' },
      { key: 'baja',         label: 'Baja' },
    ]},
  ],
  aprendizajesuperficialprofundo: [
    { key: 'id_tiposubtest',   label: 'Tarea',             type: 'select', options: [], colSpan: 2 },
    { key: 'descripcion',      label: 'Descripción',       required: true, colSpan: 2 },
    { key: 'id_usuario',       label: 'Creado por',        type: 'select', options: [] },
    { key: 'id_listavalores',  label: 'Lista de valores',  type: 'select', options: [] },
    { key: 'dificultad',       label: 'Dificultad',        type: 'pill-select', options: DIFICULTAD_OPTS, defaultValue: 1 },
    { key: 'tiempo_mili',      label: 'Tiempo (ms)',       type: 'number', defaultValue: 1500 },
    { key: 'porcentajeValido', label: 'Porcentaje válido', type: 'number', defaultValue: 0 },
    { key: 'instrucciones',    label: 'Instrucciones',     type: 'textarea', colSpan: 2 },
    { key: 'Concluciones',     label: 'Conclusiones',      type: 'textarea', colSpan: 2 },
    { key: 'observaciones',    label: 'Observaciones',     type: 'textarea', colSpan: 2 },
    { key: '_flags', label: 'Opciones', type: 'flag-group', items: [
      { key: 'baja', label: 'Baja' },
    ]},

  ],
};

const TODOS = 'todos';

export default function AdminTests() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [tipo, setTipo] = useState(TODOS);
  const [tareaList, setTareaList] = useState([]);
  const [listaOpts, setListaOpts] = useState([]);
  const [usuarioOpts, setUsuarioOpts] = useState([]);
  const [tiposCounts, setTiposCounts] = useState({});
  const [selLenguaje, setSelLenguaje] = useState(null); // { id, label }
  const [selCategoria, setSelCategoria] = useState(null); // { id, label }
  const [selTarea, setSelTarea] = useState(null); // { id, label }
  const initialized = useRef(false);

  useEffect(() => {
    getTareas().then((rows) => setTareaList(rows)).catch(() => {});

    getListas().then((rows) =>
      setListaOpts(rows.map((l) => ({ value: l.ID, label: l.baja ? `${l.Descripcion} (de baja)` : l.Descripcion })))
    ).catch(() => {});

    getUsuarios().then((rows) =>
      setUsuarioOpts(rows.map((u) => ({ value: u.ID, label: `${u.nombre} ${u.apellido}` })))
    ).catch(() => {});
  }, []);


  // Opciones para breadcrumb-select en el modal
  const lenguajeOptsBc = useMemo(() => {
    const seen = new Map();
    tareaList.forEach((t) => { if (!seen.has(t.id_lenguaje)) seen.set(t.id_lenguaje, t.lenguaje); });
    return [...seen.entries()].map(([id, label]) => ({ value: id, label }));
  }, [tareaList]);

  const catOptsBc = useMemo(() => {
    const seen = new Map();
    tareaList.forEach((t) => { if (!seen.has(t.id_tipotest)) seen.set(t.id_tipotest, { label: t.categoria, parentId: t.id_lenguaje }); });
    return [...seen.entries()].map(([id, v]) => ({ value: id, label: v.label, parentId: v.parentId }));
  }, [tareaList]);

  const tareaOptsBc = useMemo(() =>
    tareaList.map((t) => ({ value: t.ID, label: t.Descripcion, parentId: t.id_tipotest })),
    [tareaList]
  );
  // Inicializar breadcrumb desde ?tareaId en la URL
  useEffect(() => {
    if (initialized.current || tareaList.length === 0) return;
    initialized.current = true;
    const initId = searchParams.get('tareaId');
    if (!initId) return;
    const t = tareaList.find((r) => String(r.ID) === initId);
    if (!t) return;
    setSelLenguaje({ id: t.id_lenguaje, label: t.lenguaje });
    setSelCategoria({ id: t.id_tipotest, label: t.categoria });
    setSelTarea({ id: t.ID, label: t.Descripcion });
  }, [tareaList]);


  const tareaOpts = useMemo(() =>
    tareaList.map((t) => ({ value: t.ID, label: `${t.categoria} — ${t.Descripcion}` })),
    [tareaList]
  );

  const lenguajes = useMemo(() => {
    const seen = new Map();
    tareaList.forEach((t) => { if (!seen.has(t.id_lenguaje)) seen.set(t.id_lenguaje, t.lenguaje); });
    return [...seen.entries()].map(([id, label]) => ({ id, label })).sort((a, b) => a.label.localeCompare(b.label, 'es'));
  }, [tareaList]);

  const catsPorLenguaje = useMemo(() => {
    if (!selLenguaje) return [];
    const seen = new Map();
    tareaList.filter((t) => t.id_lenguaje === selLenguaje.id)
      .forEach((t) => { if (!seen.has(t.id_tipotest)) seen.set(t.id_tipotest, t.categoria); });
    return [...seen.entries()].map(([id, label]) => ({ id, label })).sort((a, b) => a.label.localeCompare(b.label, 'es'));
  }, [tareaList, selLenguaje]);

  const tareasPorCategoria = useMemo(() => {
    if (!selCategoria) return [];
    return tareaList.filter((t) => t.id_tipotest === selCategoria.id)
      .sort((a, b) => a.Descripcion.localeCompare(b.Descripcion, 'es'));
  }, [tareaList, selCategoria]);

  const tareaFilter = selTarea ? String(selTarea.id) : '';

  const filterFn = useMemo(() => {
    if (selTarea) return null;
    if (selCategoria) {
      const ids = new Set(tareaList.filter((t) => t.id_tipotest === selCategoria.id).map((t) => String(t.ID)));
      return (row) => ids.has(String(row.id_tiposubtest));
    }
    if (selLenguaje) {
      const ids = new Set(tareaList.filter((t) => t.id_lenguaje === selLenguaje.id).map((t) => String(t.ID)));
      return (row) => ids.has(String(row.id_tiposubtest));
    }
    return null;
  }, [selTarea, selCategoria, selLenguaje, tareaList]);

  const isTodos = tipo === TODOS;

  const resolveFieldsForTipo = useCallback((tipoKey) =>
    (FIELDS_BY_TIPO[tipoKey] ?? []).map((f) => {
      if (f.key === 'id_tiposubtest') return { ...f, options: tareaOpts };
      if (f.key === 'id_listavalores') return { ...f, options: listaOpts };
      if (f.key === 'id_usuario') return { ...f, options: usuarioOpts };
      return f;
    }), [tareaOpts, listaOpts, usuarioOpts]);

  const fields = isTodos
    ? (row) => resolveFieldsForTipo(row._tipoKey)
    : resolveFieldsForTipo(tipo);

  const sortPublishedFirst = (rows) =>
    [...rows].sort((a, b) => (a.baja === b.baja ? 0 : a.baja ? 1 : -1));

  const fetchAll = useCallback(async () => {
    if (tipo === TODOS) {
      const results = await Promise.all(
        TEST_TIPOS.map((t) =>
          getTests(t.key, tareaFilter || undefined)
            .then((rows) => rows.map((r) => ({ ...r, _tipoLabel: t.label, _tipoKey: t.key })))
            .catch(() => [])
        )
      );
      const counts = {};
      TEST_TIPOS.forEach((t, i) => { counts[t.key] = results[i].length; });
      setTiposCounts(counts);
      return sortPublishedFirst(results.flat());
    }
    setTiposCounts({});
    return sortPublishedFirst(await getTests(tipo, tareaFilter || undefined));
  }, [tipo, tareaFilter]);

  const onCreate = useCallback((d) => createTest(tipo, d), [tipo]);
  const onUpdate = useCallback(
    async (id, d, row) => {
      const tipoKey = isTodos ? row._tipoKey : tipo;
      const { test_mode: newTm, ...rest } = d;
      await updateTest(tipoKey, id, rest);
      if (newTm !== undefined && newTm !== row.test_mode) {
        if (newTm) await setTestMode(tipoKey, id);
        else       await unsetTestMode(tipoKey, id);
      }
    },
    [tipo, isTodos]
  );
  const onDelete = useCallback(
    (id, row) => deleteTest(isTodos ? row._tipoKey : tipo, id),
    [tipo, isTodos]
  );

  const badgeBaja = (v, row) => (
    <div className="flex flex-col items-start gap-1">
      {v
        ? <span className="inline-block px-2 py-0.5 rounded text-xs font-medium bg-red-100 text-red-600">No Publicado</span>
        : <span className="inline-block px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-700">Publicado</span>}
      {row?.lista_baja && (
        <span
          className="inline-block px-2 py-0.5 rounded text-xs font-medium bg-amber-100 text-amber-700"
          title="La lista de valores de este ejercicio está dada de baja. Si el ejercicio está publicado, se sigue viendo y funciona igual."
        >
          Usa una lista dada de baja
        </span>
      )}
    </div>
  );

  const badgeTestMode = (v) => v
    ? <span className="inline-block px-2 py-0.5 rounded text-xs font-medium bg-amber-100 text-amber-700">Testing</span>
    : null;

  const testRunLink = (row, tipoKey) => {
    const { id_lenguaje, id_categoria, id_tiposubtest, ID } = row;
    if (!id_lenguaje || !id_categoria || !id_tiposubtest) return null;
    const url = `/lenguaje/${id_lenguaje}/categoria/${id_categoria}/tarea/${id_tiposubtest}/test/${tipoKey}/${ID}?test=1`;
    return (
      <a
        href={url}
        target="_blank"
        rel="noreferrer"
        className="inline-block px-2 py-0.5 rounded text-xs font-medium bg-violet-100 text-violet-700 hover:bg-violet-200 transition-colors"
        onClick={(e) => e.stopPropagation()}
      >
        Probar →
      </a>
    );
  };

  const columnsTodos = [
    { key: '_idx', label: '#' },
    {
      key: 'descripcion',
      label: 'Descripción',
      primary: true,
      render: (v, row) => (
        <div>
          <span className="font-semibold text-slate-800">{v}</span>
          <div className="font-normal text-xs text-slate-400 mt-0.5">
            {[row.lenguaje, row.categoria, row.tarea].filter(Boolean).join(' → ')}
          </div>
        </div>
      ),
    },
    {
      key: '_tipoLabel',
      label: 'Tipo',
      render: (v) => (
        <span className="inline-block px-2 py-0.5 rounded text-xs font-medium bg-violet-100 text-violet-700">{v}</span>
      ),
    },
    {
      key: 'dificultad',
      label: 'Dificultad',
      render: (v) => <DificultadBadge value={v} />,
    },
    { key: 'creado_por', label: 'Creado por', render: (v) => v ?? '—' },
    { key: 'test_mode', label: 'Test', render: badgeTestMode },
    { key: 'baja', label: 'Estado', render: badgeBaja },
    { key: 'ID', label: '', render: (v, row) => testRunLink(row, row._tipoKey) },
  ];

  const columnsTipo = [
    { key: '_idx', label: '#' },
    {
      key: 'descripcion',
      label: 'Descripción',
      primary: true,
      render: (v, row) => (
        <div>
          <button
            type="button"
            onClick={() => navigate(`/admin/listas${row.id_listavalores ? `?listaId=${row.id_listavalores}` : ''}`)}
            className="text-left font-semibold text-violet-700 hover:text-violet-900 hover:underline bg-transparent border-0 cursor-pointer p-0"
          >
            {v}
          </button>
          <div className="font-normal text-xs text-slate-400 mt-0.5">
            {[row.lenguaje, row.categoria, row.tarea].filter(Boolean).join(' → ')}
          </div>
        </div>
      ),
    },
    {
      key: 'dificultad',
      label: 'Dificultad',
      render: (v) => <DificultadBadge value={v} />,
    },
    { key: 'creado_por', label: 'Creado por', render: (v) => v ?? '—' },
    { key: 'test_mode', label: 'Test', render: badgeTestMode },
    { key: 'baja', label: 'Estado', render: badgeBaja },
    { key: 'ID', label: '', render: (v, row) => testRunLink(row, tipo) },
  ];

  const pill = 'px-2.5 py-0.5 rounded-full text-xs font-medium border transition-colors cursor-pointer bg-slate-100 text-slate-600 border-slate-200 hover:bg-violet-100 hover:text-violet-700 hover:border-violet-300';

  const nav = (
    <div className="flex flex-col gap-2 w-full">
      <div className="flex items-center gap-1 text-sm flex-wrap">
        <button type="button" onClick={() => { setSelLenguaje(null); setSelCategoria(null); setSelTarea(null); }}
          className={`font-medium border-0 bg-transparent p-0 cursor-pointer ${!selLenguaje ? 'text-violet-700' : 'text-slate-400 hover:text-violet-600'}`}>
          Ejercicios
        </button>
        {selLenguaje && (<>
          <span className="text-slate-300">›</span>
          <button type="button" onClick={() => { setSelCategoria(null); setSelTarea(null); }}
            className={`font-medium border-0 bg-transparent p-0 cursor-pointer ${!selCategoria ? 'text-violet-700' : 'text-slate-400 hover:text-violet-600'}`}>
            {selLenguaje.label}
          </button>
        </>)}
        {selCategoria && (<>
          <span className="text-slate-300">›</span>
          <button type="button" onClick={() => setSelTarea(null)}
            className={`font-medium border-0 bg-transparent p-0 cursor-pointer ${!selTarea ? 'text-violet-700' : 'text-slate-400 hover:text-violet-600'}`}>
            {selCategoria.label}
          </button>
        </>)}
        {selTarea && (<>
          <span className="text-slate-300">›</span>
          <span className="font-medium text-violet-700">{selTarea.label}</span>
        </>)}
      </div>

      {!selLenguaje && (
        <div className="flex flex-wrap gap-1.5">
          {lenguajes.map((l) => (
            <button key={l.id} type="button" onClick={() => setSelLenguaje(l)} className={pill}>{l.label}</button>
          ))}
        </div>
      )}
      {selLenguaje && !selCategoria && (
        <div className="flex flex-wrap gap-1.5">
          {catsPorLenguaje.map((c) => (
            <button key={c.id} type="button" onClick={() => setSelCategoria(c)} className={pill}>{c.label}</button>
          ))}
        </div>
      )}
      {selCategoria && !selTarea && (
        <div className="flex flex-wrap gap-1.5">
          {tareasPorCategoria.map((t) => (
            <button key={t.ID} type="button"
              onClick={() => setSelTarea({ id: t.ID, label: t.Descripcion })}
              className={pill}>
              {t.Descripcion}
            </button>
          ))}
        </div>
      )}
    </div>
  );

  const title = 'Ejercicios';

  const tipoButtons = (
    <div className="flex flex-wrap items-center gap-1">
      <button
        onClick={() => setTipo(TODOS)}
        className={`px-2 py-0.5 rounded text-xs font-medium border transition-colors ${
          isTodos
            ? 'bg-violet-600 text-white border-violet-600'
            : 'bg-white text-slate-600 border-slate-300 hover:border-violet-400'
        }`}
      >
        Todos
      </button>
      {TEST_TIPOS.map((t) => {
        const disabled = isTodos && tiposCounts[t.key] === 0;
        return (
          <button
            key={t.key}
            onClick={() => setTipo(t.key)}
            disabled={disabled}
            className={`px-2 py-0.5 rounded text-xs font-medium border transition-colors disabled:opacity-40 disabled:cursor-not-allowed ${
              tipo === t.key
                ? 'bg-violet-600 text-white border-violet-600'
                : 'bg-white text-slate-600 border-slate-300 hover:border-violet-400'
            }`}
          >
            {t.label}
          </button>

        );
      })}

    </div>
  );

  return (
    <CrudPage
      key={tipo}
      title={title}
      titleExtra={tipoButtons}
      toolbar={nav}
      idKey="ID"
      columns={isTodos ? columnsTodos : columnsTipo}
      fields={fields}
      fetchAll={fetchAll}
      filterFn={filterFn}
      onCreate={isTodos ? null : onCreate}
      onUpdate={onUpdate}
      onDelete={onDelete}
      rowClassName={(row) => row.baja ? 'bg-slate-100 text-slate-400' : ''}
    />
  );
}
